import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import { PermissionContext } from "../../context/PermissionContext";
import Cookies from "js-cookie";

import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import {
  getNumberListApiCall,
  editNumberDataApiCall,
} from "../../Store/slices/numberSlice";

export default function ManageNumber() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(localStorage.getItem("currentPage") || 1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const location = useLocation();
  const path = location.pathname;

  const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
  const [selectedFont, setSelectedFont] = useState(localStorage.getItem("selectedFont") ?? "Ruqa");

  const [fontFilter, setFontFilter] = useState("Ruqa"); // default label
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    localStorage.setItem("modulePath", path);
    localStorage.setItem("currentPage", page);
  }, []);

  const handlePageChange = (newPage) => {
    localStorage.setItem("currentPage", newPage);
    setPage(newPage);
  };

  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const handleSortChange = (fieldName, sort) => {
    if (sort === "asc") {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(true);
    } else {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(false);
    }
  };

  const {
    numberList: { data: numberList },
  } = useSelector((state) => state.number);

  useEffect(() => {
    handleCompanyListAPI();
  }, [page, debounce, fieldSort, fontFilter]);

  const handleCompanyListAPI = () => {
    let submitData = {
      page: page,
      fieldSort,
      font: fontFilter
    };

    dispatch(getNumberListApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      await dispatch(editNumberDataApiCall(submitData));
      dispatch(
        getNumberListApiCall({
          search: debounce,
          page: page,
          fieldSort: fieldSort,
        })
      );

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };

        // console.log(
        //   "444444444444444444444444444444444444444444444444444444",
        //   submitData
        // );

        await dispatch(editNumberDataApiCall(submitData));
        await handleCompanyListAPI();
        await SWIT_DELETE_SUCCESS(`Number delete successfully`);
      }
    });
  };

  //   const handleDeleteManage = async (id) => {
  //     SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
  //       if (result?.isConfirmed) {
  //         dispatch(setLoader(true));
  //         let submitData = {
  //           id: id,
  //           status:"Inactive",
  //         };

  //         await dispatch(editClientDataApiCall(submitData));
  //         await handleCompanyListAPI();
  //         await SWIT_DELETE_SUCCESS(`Client delete successfully`);
  //       }
  //     });
  //   };

  // const handleExportApiCall = async (type) => {
  //   dispatch(setLoader(true));
  //   let submitData = {
  //     search: debounce,
  //     fieldSort,
  //   };
  //   const { code, data } = await API.getClientExportListApi(submitData);
  //   if (code === "1") {
  //     if (type === "PDF") {
  //       ExportToPdf(data, "clientList", "Client List");
  //     } else if (type === "CSV") {
  //       ExportToCSV(data, "clientList");
  //     } else if (type === "EXCEL") {
  //       ExportToExcel(data, "clientList");
  //     }
  //   }
  //   dispatch(setLoader(false));
  // };

  // console.log("*****************************************",clientList);
  const companyListData = useMemo(() => {
    return numberList?.map((item, index) => (
      <>
        {/* {console.log(
          "33333333333333333333333333333333333333333333333",
          item
        )} */}

        <tr key={index}>
          <td>{item?.id}</td>
          <td>
            <img
              src={item?.logo}
              alt="Logo"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </td>
          <td>
            <img
              src={item?.latter_image}
              alt="Latter Image"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </td>
          {/* <td>
            <img
              src={item?.background_image}
              alt="Background Image"
              style={{ width: "50px", height: "50px", objectFit: "cover" }}
            />
          </td> */}
          <td>{item?.points}</td>
          <td>{item?.is_free === "true" ? "Yes" : "No"}</td>
          {role == "admin" ||
          (permissions[5]?.module_id === 6 &&
            permissions[5]?.permission_update === 1) ? (
            <td>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`is_active_${item.id}`}
                  checked={item?.status === "Active"}
                  onChange={(e) => {
                    // console.log("e--------------------", e.target.value);
                    handleStatusChange(item?.id, item?.status);
                  }}
                />
              </div>
            </td>
          ) : (
            <td>{item?.status}</td>
          )}
          <td>{item?.font || "Ruqa"}</td>
          <td>
            <a
              className="text-reset fs-18 cursor_pointer"
              onClick={() =>
                navigate(`/manage_number/view_number_details`, {
                  state: { clientData: item },
                })
              }
            >
              {" "}
              <i className="ri-eye-line"></i>
            </a>

            {role == "admin" ||
            (permissions[5]?.module_id === 6 &&
              permissions[5]?.permission_update === 1) ? (
              <a
                className="text-reset fs-18 m-1 cursor_pointer"
                onClick={() =>
                  navigate(`/manage_number/edit_number`, {
                    state: { clientData: item },
                  })
                }
              >
                {" "}
                <i className="ri-edit-line"></i>
              </a>
            ) : null}

            {role == "admin" ||
            (permissions[5]?.module_id === 6 &&
              permissions[5]?.permission_delete === 1) ? (
              <a
                className="text-reset fs-18 cursor_pointer"
                onClick={() => handleDeleteManage(item?.id)}
              >
                {" "}
                <i className="ri-delete-bin-6-line"></i>
              </a>
            ) : null}
          </td>
        </tr>
      </>
    ));
  }, [numberList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Number`} header={`number`} />

          {role == "admin" ||
          (permissions[5]?.module_id === 6 &&
            permissions[5]?.permission_add === 1) ? (
            <div className="col-sm-6 mb-2">
              <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">
                {/* <div className="gap-2"> */}
                  <button
                    type="button"
                    className="btn btn-soft-primary"
                    onClick={() => navigate(`/manage_number/add_number`)}
                  >
                    <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                    Add Number
                  </button>

                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn btn-soft-primary dropdown-toggle"
                      onClick={() => setFontDropdownOpen(!fontDropdownOpen)}
                    >
                      {selectedFont}
                    </button>

                    {fontDropdownOpen && (
                      <ul className="dropdown-menu show" style={{ right: 0, left: "auto" }}>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              setSelectedFont("Ruqa");
                              localStorage.setItem("selectedFont", "Ruqa");
                              setFontDropdownOpen(false);
                            }}
                          >
                            Ruqa
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              setSelectedFont("Naskh");
                              localStorage.setItem("selectedFont", "Naskh");
                              setFontDropdownOpen(false);
                            }}
                          >
                            Naskh
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                {/* </div> */}
              </div>
            </div>
          ) : null}

          <div className="card rounded-3">
            <div className="card-body">
              {/* <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`client`}
                  setSearch={setSearch}
                  handleExportApiCall={handleExportApiCall}
                />
              </div> */}
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    <>
                        <table
                          id="tech-companies-1"
                          className="table table-centered mb-0 table-hover "
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Id
                              </th>

                              <th>Logo</th>

                              <th>Letter Image</th>

                              {/* <th>BackGround Image</th> */}
                              <th>Points</th>
                              <th>Free</th>
                              <th>Status</th>
                              <th style={{ position: "relative", cursor: "pointer" }}>
                                <div
                                  onClick={() => setShowDropdown(!showDropdown)}
                                  className="d-flex align-items-center"
                                >
                                  Font
                                  {/* {selectedFont} */}
                                  <i className="bi bi-caret-down-fill ms-1"></i>
                                </div>

                                {/* Dropdown */}
                                {showDropdown && (
                                  <div
                                    className="border rounded bg-white shadow-sm mt-1"
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: 0,
                                      zIndex: 1000,
                                      width: "120px",
                                    }}
                                  >
                                    <div
                                      className="p-2 dropdown-item"
                                      onClick={() => {
                                        setFontFilter("");
                                        setShowDropdown(false);
                                      }}
                                    >
                                      All
                                    </div>
                                    <div
                                      className="p-2 dropdown-item"
                                      onClick={() => {
                                        setFontFilter("Ruqa");
                                        setShowDropdown(false);
                                      }}
                                    >
                                      Ruqa
                                    </div>
                                    <div
                                      className="p-2 dropdown-item"
                                      onClick={() => {
                                        setFontFilter("Naskh");
                                        setShowDropdown(false);
                                      }}
                                    >
                                      Naskh
                                    </div>
                                  </div>
                                )}
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          
                          {Object.keys(numberList)?.length > 0 ? (
                            <tbody>{companyListData}</tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td colSpan="8">
                                  <div className="d-flex justify-content-center mt-4 mb-4">
                                    <h1 className="fs-23 m-3">{handleNoDataFound("Number")}</h1>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </>
                    
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={numberList[0]?.number_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Number`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
